// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__19xZ2","savePackageButton":"ClientWallet_savePackageButton__tTnx5"};